// PRODUCT PRICE LIST
export const PRODUCT_RECOMMENDATION_MAP_SUCCESS = 'PRODUCT_RECOMMENDATION_MAP_SUCCESS';
export const SET_PRODUCT_PRICE_RECOMMENDATIONS_CONFIRMED = 'SET_PRODUCT_PRICE_RECOMMENDATIONS_CONFIRMED';
export const UPDATE_PRODUCT_PRICE_RECOMMENDATION = 'UPDATE_PRODUCT_PRICE_RECOMMENDATION';
export const SET_FILTER_BY_PRICE_GROUP = 'SET_FILTER_BY_PRICE_GROUP';
export const SELECT_PRICE_LANGUAGE = 'SELECT_PRICE_LANGUAGE';
export const INDEXED_PRODUCT_PRICE_SUCCESS = 'INDEXED_PRODUCT_PRICE_SUCCESS';
export const USE_ONE_SERVICE_SUCCESS = 'USE_ONE_SERVICE_SUCCESS';
